<script setup>
import { SwitchRoot, SwitchThumb } from 'radix-vue';

import FieldContainer from './FieldContainer.vue';
import { fieldEmits, fieldProps, useField } from '@/composables/form/field';
import { ref } from 'vue';

const checked = ref();
const emit = defineEmits(fieldEmits());
const props = defineProps(fieldProps());
const set = (state) => {
    checked.value = state;
}

const castStateUsing = (state) => Boolean(state ?? '');

const field = useField({ props, emit, set, castStateUsing });

const onCheckUpdated = (e) => {
    checked.value = e;
    field.updateState({
        value: e,
    });
}
</script>

<template>
    <FieldContainer>
        <SwitchRoot
            :id="field.id"
            :name="field.name"
            :disabled="field.disabled"
            :checked="checked"
            :aria-required="field.required"
            @update:checked="onCheckUpdated"
            class="disabled:opacity-50 shrink-0 w-[42px] h-[25px] focus-within:outline focus-within:outline-black/30 flex bg-black/50 shadow-sm rounded-full relative data-[state=checked]:focus-within:outline-primary/30 data-[state=checked]:bg-primary/50 cursor-default"
        >
        <SwitchThumb
            class="block w-[21px] h-[21px] my-auto bg-white shadow-sm rounded-full transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:bg-primary data-[state=checked]:translate-x-[19px]"
        />
        </SwitchRoot>
    </FieldContainer>
</template>
